import { AgGrid } from "@jsq/ds/core";
import { DocumentCellRenderer } from "./DocumentCellRenderer";
import { FatcaCrsRowItem } from "./types";

type ColumnDefinitionParams = {
  caseId: number;
  documents: Array<{ id: number; name: string }>;
};

export const getColumnDefinitions = ({
  caseId,
  documents,
}: ColumnDefinitionParams): AgGrid.ColDef<FatcaCrsRowItem>[] => [
  {
    field: "profileName",
    headerName: "Profile",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "role",
    headerName: "Role",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "documentId",
    colId: "fatcaSourceDocument",
    headerName: "FATCA source document",
    minWidth: 200,
    flex: 1,
    cellRenderer: (params: AgGrid.ICellRendererParams<FatcaCrsRowItem>) => (
      <DocumentCellRenderer
        params={params}
        isApplicable={params.data?.isFatca ?? false}
        documents={documents}
        caseId={caseId}
      />
    ),
  },
  {
    field: "documentId",
    colId: "crsSourceDocument",
    headerName: "CRS source document",
    minWidth: 200,
    flex: 1,
    cellRenderer: (params: AgGrid.ICellRendererParams<FatcaCrsRowItem>) => (
      <DocumentCellRenderer
        params={params}
        isApplicable={params.data?.isCrs ?? false}
        documents={documents}
        caseId={caseId}
      />
    ),
  },
];
